import PropTypes from 'prop-types';
import React from 'react';

const ZepzFieldWrapper = ({
    name,
    label,
    children,
    isTouched,
    error
}) => (
    <div className="zepz-field-wrapper">
        <label htmlFor={name} className="zepz-field-wrapper-label">
            {label}
        </label>
        {children}
        <div className="zepz-field-error">{isTouched ? error : ''}</div>
    </div>
);


ZepzFieldWrapper.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    isTouched: PropTypes.bool,
    error: PropTypes.string
};

ZepzFieldWrapper.defaultProps = {
    isTouched: false,
    error: ''
};


export default ZepzFieldWrapper;
